import React from 'react';

/**
 * CSS-only synthwave / cybercore wireframe terrain.
 * A perspective grid scrolling toward the viewer with a glow horizon.
 */
const CyberGrid = ({ className = '' }) => {
  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      aria-hidden
    >
      <style>{`
        @keyframes cybergrid-scroll {
          0%   { background-position: 0 0; }
          100% { background-position: 0 60px; }
        }
        @keyframes cybergrid-horizon-pulse {
          0%, 100% { opacity: 0.55; }
          50%      { opacity: 0.85; }
        }
        .cybergrid-floor {
          position: absolute;
          left: -10%;
          right: -10%;
          bottom: 0;
          height: 65%;
          background-image:
            linear-gradient(rgba(0, 255, 102, 0.55) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 255, 102, 0.55) 1px, transparent 1px);
          background-size: 60px 60px;
          transform: perspective(360px) rotateX(60deg);
          transform-origin: bottom center;
          animation: cybergrid-scroll 1.6s linear infinite;
          mask-image: linear-gradient(to bottom, transparent 0%, black 18%, black 95%, transparent 100%);
          -webkit-mask-image: linear-gradient(to bottom, transparent 0%, black 18%, black 95%, transparent 100%);
        }
        .cybergrid-horizon {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 65%;
          height: 1px;
          background: #00FF66;
          box-shadow: 0 0 18px #00FF66, 0 0 32px #00FF66;
          animation: cybergrid-horizon-pulse 3.2s ease-in-out infinite;
        }
        .cybergrid-sky {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 35%;
          background: radial-gradient(ellipse at 50% 100%, rgba(0,255,102,0.18) 0%, rgba(0,255,102,0.06) 30%, transparent 65%);
        }
      `}</style>
      <div className="cybergrid-sky" />
      <div className="cybergrid-horizon" />
      <div className="cybergrid-floor" />
    </div>
  );
};

export default CyberGrid;
